import React from 'react';

function renderDelta(delta: number | null): React.ReactElement | null {
  if (delta === null || delta === undefined || delta === 0) return null;
  const positive = delta > 0;
  const text = `${positive ? '+' : ''}${Math.round(delta)}`;
  const className = positive
    ? 'text-green-600 dark:text-green-400'
    : 'text-red-600 dark:text-red-400';
  return <span className={`ml-1 text-xs ${className}`}>{text}</span>;
}

function countryDisplay(code: string): string {
  const map: Record<string, string> = {
    AU: 'Australia',
    TW: 'Taiwan',
    US: 'United States',
    CN: 'China',
    JP: 'Japan',
    GB: 'United Kingdom',
  };
  const upper = (code || '').toUpperCase();
  return map[upper] || upper;
}

export { renderDelta, countryDisplay };
